module.exports = "/img/service-2.32f1e17f.png";